module.exports = __webpack_public_path__ + "img/memberLinkedin.4eb57b67.png";